<template>
  <div class="swiper citySwiper">
    <div class="swiper-container">
      <div class="swiper-wrapper">
        <div
          v-for="(item, index) in textList"
          :key="index"
          class="swiper-slide"
          :style="
            activeIndex == item.cityCode
            ? 'background: #FF8028;'
            : 'background: #FCC81F;'
          "
          @click="dianji(item.cityCode)"
        >
          <div>
            {{item.text}}
          </div>
        </div>
      </div>
      <!-- <div class="swiper-pagination"></div> -->
    </div>
    <!-- <div class="swiper-button-next swiper-button-black"></div> -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      textList: [
        {
          text: '北京',
          cityCode: 'beijing'
        },
        {
          text: '成都',
          cityCode: 'chengdu'
        },
        {
          text: '昆明',
          cityCode: 'kunming'
        },
        {
          text: '重庆',
          cityCode: 'chongqing'
        },
        {
          text: '上海',
          cityCode: 'shanghai'
        },
        {
          text: '广州',
          cityCode: 'guangzhou'
        },
        {
          text: '哈尔滨',
          cityCode: 'haerbin'
        }
      ],
      swiperList: {
        swiper1: null,
      },
      activeIndex: 'beijing'
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.swiperList.swiper1 = new Swiper(".citySwiper .swiper-container", {
        loop: false, // 循环模式选项
        // navigation: {
        //   nextEl: ".swiper-button-next",
        //   prevEl: ".swiper-button-prev",
        // },
        pagination: {
          el: ".swiper-pagination",
          // type : 'bullets',
          // progressbarOpposite: true,
          // paginationHide: true,
          clickable:false
        },
        direction: 'vertical',
        // slideToClickedSlide: true,
        // centeredSlides : true,
        slidesPerView: 7,
        grid: {
            fill: 'column',
            rows: 1,
        },
        onSlideChangeEnd: function(swiper){
          console.log('ssss',swiper)
        }
      });
    });
  },
  methods: {
    dianji(index){
      console.log('222222222222',index)
      this.activeIndex = index
      this.$emit('switch-city', {chinaCity: index})
    },
    goNext(swiperName) {
      let swiper = this.swiperList[swiperName];
      swiper.slideNext();
    },
    goPrev(swiperName) {
      let swiper = this.swiperList[swiperName];
      swiper.slidePrev();
    },
  },
};
</script>
<style lang=less scoped='true'>
.swiper {
  &-fluid {
    position: relative;
  }
  &-top {
    position: relative;
    width: calc(100% - 26px);
    margin-left: 13px;
    margin-right: 13px;
    margin-top: 15px;
    padding-bottom: 15px;
  }
  &-cont {
    float: left;
    width: calc(100% - 164px);
    margin-left: 10px;
    text-align: left;
    font-size: 12px;
    color: #fff;
    font-weight: bold;
  }
  &-des {
    color: #f3eae5;
    font-size: 11px;
    font-weight: normal;
    margin-top: 4px;
  }
  &-container {
    position: absolute;
    left: 9px;
    top: 150px;
    width: 47px;
    margin-left: auto;
    margin-right: auto;
    .swiper-slide {
      width: 47px;
      height: 25px!important;
      box-sizing: border-box;
      background: #FCC81F;
      border-radius: 6px;
      font-size: 14px;
      font-weight: bold;
      color: #FFFCF0;
      line-height: 28px;
      margin-bottom: 2px;
    }
    /deep/ .swiper-pagination {
      display: none;
    }
    box-sizing: border-box;
    .light {
      float: left;
      &-box {
        .btn {
          padding: 2px 12px;
          border: 1px solid #feb926;
          color: #feb926;
          float: left;
          font-size: 11px;
          border-radius: 5px;
          margin-top: 8px;
          line-height: 1.414;
          margin-left: 14px;
        }
      }
      margin-top: 5px;
      img {
        width: 24px;
      }
    }
  }
  .swiper-button-black {
    position: absolute;
    left: 16px;
    top: 250px!important;
    background-image:url("https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/5.png");
    background-size: 100% auto;
    background-repeat: no-repeat;
  }
  .swiper-button-next:after {
    content: '';
  }
  swiperbutton-next,
  swiper-button-prev {
    background: url(https://picbed.qunarzz.com/80d357495b4ae2af14e7abc355f0597a.png)
      no-repeat;
    background-size: 100% auto;
    background-position: center center;
    position: absolute;
    top: 100px;
    z-index: 20;
    transform: translateY(-50%);
    -webkit-transform: translateY(-50%);
    width: 16px;
    height: 38px;
  }
  &-next {
    right: 12px;
  }
  &-prev {
    left: 12px;
    background-image: url(https://picbed.qunarzz.com/2bb4217666b9f683ba8aa0de070da123.png);
  }
}
#btn{
  background-image:url("https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/5.png");
}
.img-box2 {
  position: relative;
  height: 175px;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
    /* position: absolute;
    left: 0;
    bottom: 0; */
  }
}
.bottom {
  margin-top: 20px;
  position: relative;
}
.bottom2{
  width: 100%;
  height: 24px;
  position: absolute;
  top: 179px;
  display: block;
}
</style>